<!--
 * @Author: wumao
 * @Date: 2021-11-25 09:04:08
 * @LastEditors: wumao
 * @LastEditTime: 2021-12-20 21:06:06
 * @Description: 第二页
-->

<template>
  <Page page="02" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="分析说明" />
        <div class="area-border">
          <h4>企业基础条件</h4>
          <div class="line" v-for="(item, index) in resultData.analysisDescription.enterpriseBasicConditions" :key="index">
            <img v-if="item.accord == 1" class="icon" src="@/assets/images/yes.png" alt="" />
            <img v-else class="icon" src="@/assets/images/wrong.png" alt="" />
            <p>{{ item.descriptionResult }}</p>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="area-border">
          <h4>企业“专”“精”能力</h4>
          <div class="line" v-for="(item, index) in resultData.analysisDescription.masteryConditions" :key="index">
            <img v-if="item.accord == 1" class="icon" src="@/assets/images/yes.png" alt="" />
            <img v-else class="icon" src="@/assets/images/wrong.png" alt="" />
            <p>{{ item.descriptionResult }}</p>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from './Page.vue'
import Title from './Title.vue'
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Title,
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  .item {
    &:last-child {
      margin-top: 0.7rem;
    }
    .area-border {
      margin-top: 0.2rem;
      padding: 0.4rem 0.3rem 0.3rem 0.3rem;
      color: #333;
      font-size: 0.24rem;
      background-color: #f7fafe;
      h4 {
        margin-bottom: 0.4rem;
        color: #333;
        font-size: 0.24rem;
        font-weight: bold;
        text-align: center;
      }
      .line {
        display: flex;
        &:not(:last-child) {
          margin-bottom: 0.2rem;
        }
        .icon {
          flex-shrink: 0;
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
          margin-top: 0.02rem;
        }
        p {
          line-height: 0.32rem;
          font-size: 0.24rem;
        }
      }
    }
  }
}
</style>
